import CheckCircle from '@mui/icons-material/CheckCircle';
import Box from '@mui/material/Box';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

import { DEFAULT_COLOR_PALETTE, getContrastTextColor } from '~utils/colors';

interface ColorSwatchPickerProps<T extends FieldValues> extends UseControllerProps<T> {
  palette?: readonly string[];
  size?: number;
}

export default function ColorSwatchPicker<T extends FieldValues>({
  control,
  name,
  palette = DEFAULT_COLOR_PALETTE,
  size = 32,
}: ColorSwatchPickerProps<T>) {
  const checkIconFontSize = Math.round(size * 0.5625);

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {palette.map((colorOption) => {
            const isSelected = field.value === colorOption;

            return (
              <Box
                key={colorOption}
                data-test-id={`color-swatch-${colorOption}`}
                onClick={() => field.onChange(colorOption)}
                sx={{
                  width: size,
                  height: size,
                  borderRadius: '50%',
                  backgroundColor: colorOption,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  border: isSelected ? '2px solid' : '2px solid transparent',
                  borderColor: isSelected ? 'primary.main' : 'transparent',
                }}
              >
                {isSelected && (
                  <CheckCircle
                    data-test-id={`color-swatch-${colorOption}-selected`}
                    sx={{
                      color: getContrastTextColor(colorOption),
                      fontSize: checkIconFontSize,
                    }}
                  />
                )}
              </Box>
            );
          })}
        </Box>
      )}
    />
  );
}
